import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import {HttpPost} from "../common/HttpRequestBuilder";

const SUBSCRIPTION_KEY = environment.service_baseUrl.subscriptionKey;

const getAuthenticationPerformance = (data) => {
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.GET_AUTHENTICATION_PERFORMACE, payload, subscriptionKey);
    return result;
}

const getGeolocationVerification = (data) => {
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.GET_GEOLOCATION_VERIFICATION, payload, subscriptionKey);
    return result;
}

const getAnomalyDetection = (data) => {
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.GET_ANOMALY_DETECTION, payload, subscriptionKey);
    return result;
}

const getAlertList = (data) => {
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.GET_ALERT_LIST, payload, subscriptionKey);
    return result;
}

const getVerificationFrequency = (data) => {
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.GET_VERIFICATION_FREQUENCY, payload, subscriptionKey);
    return result;
}

const getProductVerification = (data) => {
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.GET_PRODUCT_VERIFICATION, payload, subscriptionKey);
    return result;
}

const getUserActivity = (data) => {
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.GET_USER_ACTIVITY, payload, subscriptionKey);
    return result;
}

const exportAlertAndNotifReport = (data) =>{
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.EXPORT_ALERT_NOTIFICATION, payload, subscriptionKey);
    return result;
}

const exportAnomalyDetectionReport = (data) =>{
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.EXPORT_ANOMALY_DETECTION, payload, subscriptionKey);
    return result;
}

const exportAuthenticationPerformance = (data) =>{
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.EXPORT_AUTHENTICATION_PERFORMANCE, payload, subscriptionKey);
    return result;
}

const exportGeolocationVerification = (data) =>{
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.EXPORT_GEOLOCATION_VERIFICATION, payload, subscriptionKey);
    return result;
}

const exportProductVerification = (data) =>{
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.EXPORT_PRODUCT_VERIFICATION, payload, subscriptionKey);
    return result;
}

const exportUserActivity = (data) =>{
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.EXPORT_USER_ACTIVITY, payload, subscriptionKey);
    return result;
}

const exportVerificationFrequency = (data) =>{
    let payload = data; 
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.EXPORT_VERIFICATION_FREQUENCY, payload, subscriptionKey);
    return result;
}

const ReportService = {
    getAuthenticationPerformance: getAuthenticationPerformance,
    getGeolocationVerification: getGeolocationVerification,
    getAnomalyDetection: getAnomalyDetection,
    getAlertList: getAlertList,
    getVerificationFrequency: getVerificationFrequency,
    getProductVerification: getProductVerification,
    getUserActivity: getUserActivity,
    exportAlertAndNotifReport: exportAlertAndNotifReport,
    exportAnomalyDetectionReport: exportAnomalyDetectionReport,
    exportAuthenticationPerformance: exportAuthenticationPerformance,
    exportGeolocationVerification: exportGeolocationVerification,
    exportProductVerification: exportProductVerification,
    exportUserActivity: exportUserActivity,
    exportVerificationFrequency: exportVerificationFrequency,
}

export default ReportService
